import React from 'react';
import moment from "moment";

function formatDate(date) {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

 //   Formatting Data
function getDateOfBirth(time) {  
  if(time) {
    let date = new Date(time);
    let month = date.getMonth() + 1;
    let finalDate = date.getFullYear() + "/" + month + "/" + date.getDate();
    return moment(moment(finalDate).format("MM/DD/YYYY"));
  } else return;
}

function mapContents(array, obj){
  obj.heading = array[0]?.field_header;
  obj.line1 = array[0]?.field_description;
  obj.continue = array[0]?.field_alert_button1_text;
  obj.cancel = array[0]?.field_alert_button2_text;
  return obj;
}

function getAlert(allAlerts, title){
  return allAlerts.filter(obj => {
     return obj.name.trim().toLowerCase() === title.trim().toLowerCase();
  })
}

function getAlertDescForActivity(allAlerts,title){
  let obj = allAlerts.filter(obj => {
    return obj.name.trim().toLowerCase() === title.trim().toLowerCase();
  })
  return <span dangerouslySetInnerHTML={{__html: obj[0].field_description}} />
}

export {
  formatDate, getDateOfBirth, getAlert, mapContents, getAlertDescForActivity
}
